import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { I18nextProvider, initI18n } from '@wix/wix-i18n-config';
import { ExperimentsProvider } from '@wix/wix-experiments-react';
import { WixStyleReactProvider, FontUpgrade } from 'wix-style-react';
import { LoggerProvider } from './client/appContext/LoggerProvider';
import { StoreProvider } from './client/appContext/StoreProvider';
import ErrorBoundary from './client/components/ErrorBoundary';
import { ClientStore } from './Store/StoresObjects/ClientStore';
import { ViewerWrapper } from './Viewer/ViewerWrapper';
import { docsStore } from './common/redux/AppStore';
import { initHttpClient } from './common/utils/httpClient';
import { HttpClient } from '@wix/http-client';
import App from './client/components/App';
import { removeTrailingSlashes } from './utils/locationUtils';

const storeMode = window.__STORE_MODE__;
const storePath = window.__STORE_PATH__;
const assetsBaseUrl = window.__ASSETS_BASE_URL__;
const baseUrl = window.__BASEURL__;
const staticsBaseUrl = window.__DOCS_STATICS_BASE_URL__;
const experiments = window.__EXPERIMENTS__;
const storeId = window.__STORE_ID__;
const viewer = new ViewerWrapper(window.__VIEWER__);

initHttpClient(
  new HttpClient({
    baseURL: `${removeTrailingSlashes(window.location.origin + baseUrl)}`,
  }),
);

window.Sentry.onLoad(() => {
  window.Sentry.init({
    environment: process.env.NODE_ENV,
    enabled: process.env.NODE_ENV === 'production',
    release: `${viewer.artifactId}@${viewer.currentVersion}`,
    attachStacktrace: true,
  });
  window.Sentry.configureScope((scope: any) => {
    try {
      scope.setTag('experiments', `${JSON.stringify(experiments)}`);
    } catch (e) {
      console.error(e);
    }
  });
});

const i18n = initI18n({
  locale: window.__LOCALE__,
  messages: window.__MESSAGES__,
});

const store = new ClientStore({
  id: storeId,
  baseUrl,
  assetsBaseUrl,
  storePath,
  staticsBaseUrl,
  storeMode,
  viewer,
  experiments,
});

window.docsStore = docsStore;
window.store = store;

store.initStoreData().then(() => {
  ReactDOM.hydrate(
    <Router basename={storePath}>
      <I18nextProvider i18n={i18n}>
        <LoggerProvider artifactId={viewer.artifactId}>
          <ExperimentsProvider experiments={experiments}>
            <ErrorBoundary>
              <StoreProvider store={store}>
                <Provider store={window.docsStore}>
                  <WixStyleReactProvider
                    features={{
                      reducedSpacingAndImprovedLayout: true,
                    }}
                  >
                    <FontUpgrade>
                      <App />
                    </FontUpgrade>
                  </WixStyleReactProvider>
                </Provider>
              </StoreProvider>
            </ErrorBoundary>
          </ExperimentsProvider>
        </LoggerProvider>
      </I18nextProvider>
    </Router>,
    document.getElementById('root'),
  );
});
